import { invert } from 'lodash';

export const LG = `LG`;
export const MD = `MD`;
export const MODULE_NAME = 'clientInfo';
export const SM = `SM`;
export const XL = `XL`;
export const XS = `XS`;

/**
 * Enum supported platforms.
 * @enum {string}
 */
export const CLIENT_PLATFORM = {
	ANDROID: 'ANDROID',
	IOS: 'IOS',
	WEB: 'WEB',
};

export const DARK_MODE_CLASS_NAME = 'dark';
// Used also as sessionStorage token for indicating popUpBrowser environment
export const POP_UP_BROWSER_CLASS_NAME = 'inAppBrowser';

/**
 * Enum screen orientation.
 * @enum {string}
 */
export const SCREEN_ORIENTATION = {
	LANDSCAPE: 'LANDSCAPE',
	PORTRAIT: 'PORTRAIT',
};

/**
 * The breakpoints are coppied from the Bootstrap
 * node_modules/bootstrap/scss/_variables.scss:190
 */
export const SCREEN_SIZE = {
	[XS]: 0,
	[SM]: 576,
	[MD]: 768,
	[LG]: 992,
	[XL]: 1200,
};

export const BREAKPOINTS = invert(SCREEN_SIZE);

export const SCREEN_SIZE_ORDER = [XS, SM, MD, LG, XL];

export const MOBILE_SCREEN_SIZE = SCREEN_SIZE.SM;
